// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.picklist-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  transition: opacity 0.3s ease;
}

.picklist-modal-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.picklist-modal {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: modalSlideIn 0.3s ease;
}
@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.picklist-modal-header {
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
}
.picklist-modal-header h2 {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}
.picklist-modal-header p {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}

.picklist-modal-content {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
}

.picklist-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.picklist-column h3 {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
}

.picklist-values {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.picklist-value-row {
  min-height: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.picklist-value-required {
  color: #ef4444;
  font-weight: 600;
  min-width: 8px;
}

.picklist-value-label {
  font-size: 14px;
  color: #374151;
  padding: 8px 0;
}

.picklist-select {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 14px;
  color: #374151;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}
.picklist-select:hover {
  border-color: #9ca3af;
}
.picklist-select:focus {
  outline: none;
  border-color: #40a0c1;
  box-shadow: 0 0 0 3px rgba(64, 160, 193, 0.1);
}
.picklist-select option {
  padding: 8px;
}

.picklist-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.picklist-modal-footer button {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}
.picklist-modal-footer button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.picklist-modal-footer button:active {
  transform: translateY(0);
}
.picklist-modal-footer .btn-secondary {
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
}
.picklist-modal-footer .btn-secondary:hover {
  background-color: #e5e7eb;
}
.picklist-modal-footer .btn-primary {
  background-color: #40a0c1;
  color: white;
}
.picklist-modal-footer .btn-primary:hover {
  background-color: #358ba8;
}

.picklist-custom-dropdown {
  position: relative;
  width: 100%;
}

.picklist-dropdown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 32px 8px 12px;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #374151;
  min-height: 40px;
  position: relative;
  box-sizing: border-box;
  transition: all 0.2s ease;
}
.picklist-dropdown-header:hover {
  border-color: #9ca3af;
}
.picklist-dropdown-header.open {
  border-color: #40a0c1;
  box-shadow: 0 0 0 3px rgba(64, 160, 193, 0.1);
}

.picklist-dropdown-text {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.picklist-dropdown-arrow {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  transition: transform 0.2s;
}
.picklist-dropdown-arrow.open {
  transform: translateY(-50%) rotate(180deg);
}

.picklist-dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  display: flex;
  flex-direction: column;
  min-width: 100%;
}

.picklist-dropdown-search {
  padding: 8px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
  background: white;
  display: flex;
  align-items: center;
  gap: 8px;
}

.picklist-dropdown-search-input {
  flex: 1 1;
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 14px;
  color: #374151;
  outline: none;
  box-sizing: border-box;
}
.picklist-dropdown-search-input:focus {
  border-color: #40a0c1;
}
.picklist-dropdown-search-input::placeholder {
  color: #9ca3af;
}

.picklist-dropdown-options {
  max-height: 280px;
  overflow-y: auto;
}
.picklist-dropdown-options::-webkit-scrollbar {
  width: 6px;
}
.picklist-dropdown-options::-webkit-scrollbar-track {
  background: #f3f4f6;
  border-radius: 4px;
}
.picklist-dropdown-options::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}
.picklist-dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

.picklist-dropdown-option {
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #374151;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background 0.15s;
  gap: 12px;
}
.picklist-dropdown-option:hover {
  background: #f3f4f6;
}
.picklist-dropdown-option.selected {
  background: #e8f4f8;
  color: #40a0c1;
  font-weight: 500;
}
.picklist-dropdown-option.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.picklist-option-label {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.picklist-option-badges {
  display: inline-flex;
  gap: 4px;
  margin-left: 8px;
}

.picklist-badge {
  display: inline-block;
  padding: 2px 6px;
  background: #e0f2f1;
  color: #00695c;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.picklist-value-row {
  position: relative;
  overflow: visible !important;
}

@media (max-width: 768px) {
  .picklist-grid {
    grid-template-columns: 1fr;
  }
  .picklist-modal {
    max-width: 100%;
    max-height: 100vh;
    border-radius: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Integrations/HubspotIntegration/components/modals/PicklistMappingModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,6BAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iCAAA;AACF;AACE;EACE;IACE,UAAA;IACA,4BAAA;EACJ;EACE;IACE,UAAA;IACA,wBAAA;EACJ;AACF;;AAGA;EACE,aAAA;EACA,gCAAA;AAAF;AAEE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAGE;EACE,SAAA;EACA,eAAA;EACA,cAAA;AADJ;;AAKA;EACE,aAAA;EACA,gBAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAFF;;AAME;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAHJ;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAJF;;AAOA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAJF;;AAOA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AAJF;;AAOA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAJF;;AAOA;EACE,SAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAJF;AAME;EACE,qBAAA;AAJJ;AAOE;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AALJ;AAQE;EACE,YAAA;AANJ;;AAUA;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;AAPF;AASE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AAPJ;AASI;EACE,2BAAA;EACA,wCAAA;AAPN;AAUI;EACE,wBAAA;AARN;AAYE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAVJ;AAYI;EACE,yBAAA;AAVN;AAcE;EACE,yBAAA;EACA,YAAA;AAZJ;AAcI;EACE,yBAAA;AAZN;;AAkBA;EACE,kBAAA;EACA,WAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,0BAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAfF;AAiBE;EACE,qBAAA;AAfJ;AAkBE;EACE,qBAAA;EACA,6CAAA;AAhBJ;;AAoBA;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,0BAAA;AAjBF;AAmBE;EACE,0CAAA;AAjBJ;;AAqBA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,4CAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,gCAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAlBF;;AAqBA;EACE,SAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AAlBF;AAoBE;EACE,qBAAA;AAlBJ;AAqBE;EACE,cAAA;AAnBJ;;AAuBA;EACE,iBAAA;EACA,gBAAA;AApBF;AAsBE;EACE,UAAA;AApBJ;AAuBE;EACE,mBAAA;EACA,kBAAA;AArBJ;AAwBE;EACE,mBAAA;EACA,kBAAA;AAtBJ;AAwBI;EACE,mBAAA;AAtBN;;AA2BA;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4BAAA;EACA,SAAA;AAxBF;AA0BE;EACE,mBAAA;AAxBJ;AA2BE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AAzBJ;AA4BE;EACE,mBAAA;EACA,YAAA;AA1BJ;;AA8BA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA3BF;;AA8BA;EACE,oBAAA;EACA,QAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,4BAAA;AA3BF;;AA+BA;EACE;IACE,0BAAA;EA5BF;EA+BA;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;EA7BF;AACF","sourcesContent":[".picklist-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9998;\n  transition: opacity 0.3s ease;\n}\n\n.picklist-modal-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 20px;\n}\n\n.picklist-modal {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  max-width: 800px;\n  width: 100%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  animation: modalSlideIn 0.3s ease;\n\n  @keyframes modalSlideIn {\n    from {\n      opacity: 0;\n      transform: translateY(-20px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n}\n\n.picklist-modal-header {\n  padding: 24px;\n  border-bottom: 1px solid #e5e7eb;\n\n  h2 {\n    margin: 0 0 8px 0;\n    font-size: 20px;\n    font-weight: 600;\n    color: #1f2937;\n  }\n\n  p {\n    margin: 0;\n    font-size: 14px;\n    color: #6b7280;\n  }\n}\n\n.picklist-modal-content {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.picklist-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n.picklist-column {\n  h3 {\n    margin: 0 0 16px 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #374151;\n  }\n}\n\n.picklist-values {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.picklist-value-row {\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.picklist-value-required {\n  color: #ef4444;\n  font-weight: 600;\n  min-width: 8px;\n}\n\n.picklist-value-label {\n  font-size: 14px;\n  color: #374151;\n  padding: 8px 0;\n}\n\n.picklist-select {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 14px;\n  color: #374151;\n  background-color: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    border-color: #9ca3af;\n  }\n\n  &:focus {\n    outline: none;\n    border-color: #40a0c1;\n    box-shadow: 0 0 0 3px rgba(64, 160, 193, 0.1);\n  }\n\n  option {\n    padding: 8px;\n  }\n}\n\n.picklist-modal-footer {\n  padding: 16px 24px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n\n  button {\n    padding: 8px 16px;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: none;\n\n    &:hover {\n      transform: translateY(-1px);\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    }\n\n    &:active {\n      transform: translateY(0);\n    }\n  }\n\n  .btn-secondary {\n    background-color: #f3f4f6;\n    color: #374151;\n    border: 1px solid #d1d5db;\n\n    &:hover {\n      background-color: #e5e7eb;\n    }\n  }\n\n  .btn-primary {\n    background-color: #40a0c1;\n    color: white;\n\n    &:hover {\n      background-color: #358ba8;\n    }\n  }\n}\n\n// Custom Dropdown styles for picklist values\n.picklist-custom-dropdown {\n  position: relative;\n  width: 100%;\n}\n\n.picklist-dropdown-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 32px 8px 12px;\n  background: white;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #374151;\n  min-height: 40px;\n  position: relative;\n  box-sizing: border-box;\n  transition: all 0.2s ease;\n\n  &:hover {\n    border-color: #9ca3af;\n  }\n\n  &.open {\n    border-color: #40a0c1;\n    box-shadow: 0 0 0 3px rgba(64, 160, 193, 0.1);\n  }\n}\n\n.picklist-dropdown-text {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.picklist-dropdown-arrow {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  transition: transform 0.2s;\n\n  &.open {\n    transform: translateY(-50%) rotate(180deg);\n  }\n}\n\n.picklist-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 10000;\n  display: flex;\n  flex-direction: column;\n  min-width: 100%;\n}\n\n.picklist-dropdown-search {\n  padding: 8px;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n  background: white;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.picklist-dropdown-search-input {\n  flex: 1;\n  padding: 6px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 14px;\n  color: #374151;\n  outline: none;\n  box-sizing: border-box;\n\n  &:focus {\n    border-color: #40a0c1;\n  }\n\n  &::placeholder {\n    color: #9ca3af;\n  }\n}\n\n.picklist-dropdown-options {\n  max-height: 280px;\n  overflow-y: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f3f4f6;\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #d1d5db;\n    border-radius: 4px;\n\n    &:hover {\n      background: #9ca3af;\n    }\n  }\n}\n\n.picklist-dropdown-option {\n  padding: 10px 12px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  transition: background 0.15s;\n  gap: 12px;\n\n  &:hover {\n    background: #f3f4f6;\n  }\n\n  &.selected {\n    background: #e8f4f8;\n    color: #40a0c1;\n    font-weight: 500;\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n}\n\n.picklist-option-label {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.picklist-option-badges {\n  display: inline-flex;\n  gap: 4px;\n  margin-left: 8px;\n}\n\n.picklist-badge {\n  display: inline-block;\n  padding: 2px 6px;\n  background: #e0f2f1;\n  color: #00695c;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.picklist-value-row {\n  position: relative;\n  overflow: visible !important;\n}\n\n// Responsive design for smaller screens\n@media (max-width: 768px) {\n  .picklist-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .picklist-modal {\n    max-width: 100%;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
